export enum PURCHASES_ERROR_TYPES {
	FULL_PAGE_ERROR = 'full_page_error',
	PARTIAL_ERROR = 'partial_error',
	SERVER_ERROR = 'server_error',
	NO_PURCHASES_FOUND = 'no_purchases_found',
}
